module.exports = __webpack_public_path__ + "img/Med-Fre.d6f0f69b.jpg";